import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import type { Recording } from '@minutes-system/backend/src/api/recordings/schema';
import {
  RecordingCard as Card,
  CardTitleRow,
  CardTitle,
  CardInfo,
  InfoRow,
  InfoLabel,
  InfoValue,
  StatusTag,
} from './RecordingCard.style';
import formatDuration from '../../utils/formatDuration';

const statusConfig: Record<number, { label: string; color: string }> = {
  1: { label: '処理中', color: 'gold' },
  2: { label: '完了', color: 'green' },
  3: { label: '失敗', color: 'red' },
};

const callDirectionConfig: Record<string, { label: string; color: string }> = {
  outgoing: { label: '架電', color: 'blue' },
  incoming: { label: '受電', color: 'purple' },
};

interface Props {
  recording: Recording;
}

const RecordingCard = ({ recording }: Props): ReactElement => {
  const navigate = useNavigate();
  const status = statusConfig[recording.recordingStatusId] ?? { label: '不明', color: 'default' };
  const directionTag = callDirectionConfig[recording.callDirection];

  const handleClick = (): void => {
    void navigate(`/recordings/${String(recording.id)}`);
  };

  return (
    <Card onClick={handleClick}>
      <CardTitleRow>
        <CardTitle>{recording.title}</CardTitle>
        {directionTag !== undefined && (
          <StatusTag color={directionTag.color} bordered={false}>
            {directionTag.label}
          </StatusTag>
        )}
      </CardTitleRow>
      <CardInfo>
        <InfoRow>
          <InfoLabel>顧客名:</InfoLabel>
          <InfoValue>{recording.customerName ?? '-'}</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>担当者名:</InfoLabel>
          <InfoValue>{recording.advisorName ?? '-'}</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>録音時間:</InfoLabel>
          <InfoValue>{recording.duration !== null ? formatDuration(recording.duration) : '不明'}</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>録音日:</InfoLabel>
          <InfoValue>{dayjs(recording.meetingDateTime).format('YYYY-MM-DD HH:mm:ss')}</InfoValue>
        </InfoRow>
        <InfoRow>
          <StatusTag color={status.color} bordered={false}>
            {status.label}
          </StatusTag>
        </InfoRow>
      </CardInfo>
    </Card>
  );
};

export default RecordingCard;
